// ** React Imports
import { useState ,useEffect} from "react";
import { useNavigate } from "react-router-dom";
// ** Redux Imports
import { useDispatch, useSelector } from "react-redux"; // Add this import
// import { handleSelectEvent } from "store/apps/calendar"; // Add this import

import {
  addEvent,
  fetchEvents,
  deleteEvent,
  updateEvent,
  handleSelectEvent,
  handleAllCalendars,
  handleCalendarsUpdate,
} from "store/apps/calendar";

// ** MUI Imports
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  CircularProgress,
  Backdrop,
  Button,
  IconButton,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Tab from "@mui/material/Tab";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import useMediaQuery from "@mui/material/useMediaQuery";
import dayjs from "dayjs";

// ** Component Imports
import Calendar from "./component/calendar";
import JobList from "./component/job-list";

// ** Icon Imports
import Icon from "../../components/icon";

// ** Third Party Components
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

// ** Layout Import
import UserLayout from "../../components/layouts/UserLayout";

// ** Logic Imports
import { useDispatchBoardPermission } from "./permissions/DispatchBoardPermissions";
import AddEventSidebar from "./component/calendar/AddEventSidebar";
import MapComponent from "./component/map/map";
import { getAssests, getJobs, getLabors } from "./logic/DispatchBoardLogic";
import { convertESTToLocalDateTime, formatDate, formatDate2, getCurrentDate2, getDate, GetFormatedTimeStamp, utcToLocalDate, utcToLocalDateTime } from "components/formatDate";


const DispatchBoard = () => {
  //#region Permissions
  const { DispatchBoardPermissionProps } = useDispatchBoardPermission();
  const {
    hasDbGetPermission,
    hasDbSavePermission,
    hasDbDeletePermission
  } = DispatchBoardPermissionProps;
  //#endregion Permissions

  //#region Hooks and Vars
  const MySwal = withReactContent(Swal);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md')); 
  const dispatch = useDispatch(); // Add this hook
  const store = useSelector((state) => state.calendar);
  //#endregion Hooks and Vars

  //#region States
  const contentHeightFixed = false;
  const [loading, setLoading] = useState(false);
  const [tabValue, setTabValue] = useState("1");
  const [selectedButton, setSelectedButton] = useState("all");
  const [openSidebar, setOpenSidebar] = useState(true);
  const [addEventSidebarOpen, setAddEventSidebarOpen] = useState(false); // Add this state
  const [calendarApi, setCalendarApi] = useState(null);
  
  const [jobListRefreshKey, setJobListRefreshKey] = useState(0);
  const [jobSites, setJobSite] = useState([]); // Store job sites
  const [jobAssets, setJobAssets] = useState([]); // Store job assets
  const [jobLabor, setJobLabor] = useState([]); // Store job labor
 //Map States

 const [selectedDate, setSelectedDate] = useState(new Date());
 const [selectedJobSite, setSelectedJobSite] = useState(null);
 
 // Shared date filter for Calendar and JobList
 const [calendarSelectedDate, setCalendarSelectedDate] = useState(null);
 const [calendarViewType, setCalendarViewType] = useState('dayGridMonth'); // Track calendar view type
 
 // Shared filters for Status, Service, Industry
 const [appliedFilters, setAppliedFilters] = useState({
   statuses: [],
   services: [],
   industries: []
 });
 const Google_API_Key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyBcJuFoHy00E4JN99X9jPSKpu62mV04ZA8';
  //#endregion states

  //#region Handlers

useEffect(() => {  
  if(tabValue === "2"){
    fetchAllData(selectedDate);
  }
},[tabValue]);

const handleDateChange = (date) =>{
  setSelectedDate(date);
  setSelectedJobSite(null);
  //const dateStr = getDate(date);
  fetchAllData(date);
}
  
const fetchAllData = async (date = new Date().toString()) => {
  setLoading(true);
  try {
    const jobsData = await getJobs(date, navigate);
    
    if (jobsData && !jobsData.isError) {
      // Process jobs data
      let allJobs = [];
      let allAssets = [];
      let allLabor = [];
      
      for (let jobsite of (jobsData.result || [])) {
        if (jobsite.jobDetails && Array.isArray(jobsite.jobDetails)) {
         
          const jobsiteJobs = jobsite.jobDetails.map(job => {
          
         const flagNames = job.flags && Array.isArray(job.flags) 
              ? job.flags
                  .map(flag => flag.flagName)
                  .filter(name => name)
                  .join(', ') 
              : '';
            return {
              id: job.jobID,
              title: job.serviceName,
              address: jobsite.jobsiteAddress, 
              jobsiteID: jobsite.jobsiteID,
              jobsiteName: jobsite.jobsiteName,
              totalBudgetHrs: jobsite.totalBudgetedHours,
              totalJobs: jobsite.totalJobs,
              completedJobs: jobsite.completedJobs,
              customerName: jobsite.customerName,
              status: job.jobStatus || 'Unscheduled',
              serviceName: job?.serviceName,          
              startDate: job.scheduleStartDate && job.scheduleStartTime
                ? utcToLocalDateTime(`${dayjs(job.scheduleStartDate).format('YYYY-MM-DD')}T${job.scheduleStartTime}`)
                : job.scheduleStartDate
                  ? dayjs(job.scheduleStartDate).format('MM-DD-YYYY')
                  : null,
              endDate: job.scheduleEndDate && job.scheduleEndTime
                ? utcToLocalDateTime(`${dayjs(job.scheduleEndDate).format('YYYY-MM-DD')}T${job.scheduleEndTime}`)
                : job.scheduleEndDate
                  ? dayjs(job.scheduleEndDate).format('MM-DD-YYYY')
                  : null,
              flagNames: flagNames 
            };
          });               
          allJobs = [...allJobs, ...jobsiteJobs];

          jobsite.jobDetails.forEach(job => {
            
          const flagNames = job.flags && Array.isArray(job.flags) 
              ? job.flags
                  .map(flag => flag.flagName)
                  .filter(name => name)
                  .join(', ') 
              : '';
            
            if (job.assets && Array.isArray(job.assets)) {
              const jobAssets = job.assets.map(asset => ({
                id: asset.assetID,
                jobId: job.jobID,
                title: asset.assetName,
                address: jobsite.jobsiteAddress,
                jobsiteID: jobsite.jobsiteID,
                jobsiteName: jobsite.jobsiteName,
                totalBudgetHrs: jobsite.totalBudgetedHours,
                totalJobs: jobsite.totalJobs,
                status: job.jobStatus || 'Unscheduled',
                customerName: jobsite.customerName,
                serviceName: job.serviceName,
                startDate: job.scheduleStartDate && job.scheduleStartTime
                  ? utcToLocalDateTime(`${dayjs(job.scheduleStartDate).format('YYYY-MM-DD')}T${job.scheduleStartTime}`)
                  : job.scheduleStartDate
                    ? dayjs(job.scheduleStartDate).format('MM-DD-YYYY')
                    : null,
                flagNames: flagNames 
              }));
              allAssets = [...allAssets, ...jobAssets];
            }

            // Process labor from each job
            if (job.labor && Array.isArray(job.labor)) {
              const jobLabor = job.labor.map(labor => ({
                id: labor.employeeID,
                jobId: job.jobID,
                title: labor.employeeName,
                employeeName: labor.employeeName,
                address: jobsite.jobsiteAddress,
                jobsiteID: jobsite.jobsiteID,
                jobsiteName: jobsite.jobsiteName,
                customerName: jobsite.customerName,
                serviceName: job.serviceName,
                skillType: labor.skillType || '',
                status: job.jobStatus || 'Unscheduled',
                totalBudgetHrs: jobsite.totalBudgetedHours,
                totalJobs: jobsite.totalJobs,
                startDate: job.scheduleStartDate && job.scheduleStartTime
                  ? utcToLocalDateTime(`${dayjs(job.scheduleStartDate).format('YYYY-MM-DD')}T${job.scheduleStartTime}`)
                  : job.scheduleStartDate
                    ? dayjs(job.scheduleStartDate).format('MM-DD-YYYY')
                    : null,
                flagNames: flagNames 
              }));
              allLabor = [...allLabor, ...jobLabor];
            }
          });
        }
      }
      
      setJobSite(allJobs);
      setJobAssets(allAssets);
      setJobLabor(allLabor);
    } else {
      toast.error(jobsData?.message || "Error fetching data");
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    toast.error(error.message || "Error fetching data");
  } finally {
    setLoading(false);    
  }
}
const handleFilterClick = () => {
  // Handle filter logic
  console.log('Filter clicked')
}
  const handleTabChange = (event, newValue) => {
    setSelectedJobSite(null);
    setTabValue(newValue);
  };

  const toggleButton = (button) => {
    setSelectedButton(button);
  };

  const toggleSideBar = () => {
    setOpenSidebar(!openSidebar)
  }

  // Add this handler for the sidebar
  const handleAddEventSidebarToggle = () => {
    setAddEventSidebarOpen(!addEventSidebarOpen);
  };
  //#endregion Handlers

  return (
    <UserLayout
      contentHeightFixed={contentHeightFixed}
      activeLink={"Dispatch Board"}
    >
      <Card sx={{ width: "100%", height: "100%", position: "relative" , p: { xs: 1, sm: 2 }}}>
         <CardContent
          sx={{
            p: { xs: 0, sm: 2 },
            "&:last-child": { pb: { xs: 0, sm: 2 } },
          }}
        >
          <Box>
            <TabContext value={tabValue}>
              <TabList
                sx={{ mb: 2 }}
                onChange={handleTabChange}
                aria-label="simple tabs example"
              >
                <Tab
                  value="1"
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        width: "100%",
                        color: theme.palette.mode === 'dark' ? 
                          tabValue === "1" ? "#fff" : "inherit" :
                          "inherit"
                      }}
                    >
                      <Box
                        sx={{
                          fontSize: { xs: '0.875rem', md: "1rem" },
                          fontWeight: 500,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Calendar
                      </Box>
                    </Box>
                  }
                />
                <Tab
                  value="2"
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        width: "100%",
                        color: theme.palette.mode === 'dark' ? 
                          tabValue === "2" ? "#fff" : "inherit" :
                          "inherit"
                      }}
                    >
                      <Box
                        sx={{
                          fontSize: { xs: '0.875rem', md: "1rem" },
                          fontWeight: 500,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Map
                      </Box>
                    </Box>
                  }
                />
              </TabList>
              <TabPanel value="1">
                <Grid container spacing={5}>
                  <Grid
                    item
                    xs={12}
                    md={openSidebar ? 3 : 0.5}
                    sx={{
                      backgroundColor: openSidebar
                        ? "rgba(49, 113, 149, 0.05)"
                        : "background.paper",
                      pr: openSidebar ? 5 : 0,
                      position: "relative",
                      transition: "all 0.3s ease",
                      overflow: "visible",
                    }}
                  >
                    <Box>
                      <Box
                        sx={{
                          position: "absolute",
                          right: "-12px",
                          ...(isMobile &&
                            !openSidebar && {
                              right: "auto",
                              left: "0",
                              transform: "translateX(-3px)",
                              top: "5px",
                            }),
                          top: "15px",
                          display: "flex",
                          alignItems: "center",
                          zIndex: 100,
                          transition: "transform 0.3s ease",
                        }}
                        onClick={toggleSideBar}
                      >
                        <IconButton
                          sx={{
                            backgroundColor: "#a3e2b9", 
                            border: `1px solid ${theme.palette.divider}`,
                            zIndex: 2,
                            width: "30px", 
                            height: "30px",
                            color: "primary.main",
                            "&:hover": {
                              backgroundColor: "#a3e2b9", 
                            },
                          }}
                          size="small"
                        >
                          <Icon
                            icon={
                              openSidebar
                                ? "tabler:chevron-left"
                                : "tabler:chevron-right"
                            }
                          />
                        </IconButton>
                      </Box>

                      {openSidebar && (
                        <>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 2,
                              flexWrap: "wrap",
                              mb: 4,
                            }}
                          >
                            <Button
                              variant={
                                selectedButton === "all" ? "contained" : "tonal"
                              }
                              color="info"
                              size="small"
                              onClick={() => toggleButton("all")}
                            >
                              All
                            </Button>
                            <Button
                              variant={
                                selectedButton === "scheduled"
                                  ? "contained"
                                  : "tonal"
                              }
                              color="info"
                              size="small"
                              onClick={() => toggleButton("scheduled")}
                            >
                              Scheduled
                            </Button>
                            <Button
                              variant={
                                selectedButton === "Unscheduled"
                                  ? "contained"
                                  : "tonal"
                              }
                              color="info"
                              size="small"
                              onClick={() => toggleButton("Unscheduled")}
                            >
                              Unscheduled
                            </Button>
                            <Button
                              variant={
                                selectedButton === "dispatched"
                                  ? "contained"
                                  : "tonal"
                              }
                              color="info"
                              size="small"
                              onClick={() => toggleButton("dispatched")}
                            >
                              Dispatched
                            </Button>
                          </Box>
                          {hasDbGetPermission && (
                            <Box>
                              <JobList
                                toast={toast}
                                filterType={selectedButton}
                                refreshKey={jobListRefreshKey}
                                onOpenAddEventSidebar={handleAddEventSidebarToggle}
                                onSelectEvent={(event) => dispatch(handleSelectEvent(event))}
                                onJobCreated={() => setJobListRefreshKey((k) => k + 1)}
                                selectedDate={calendarSelectedDate}
                                calendarViewType={calendarViewType}
                                appliedFilters={appliedFilters}
                              />
                            </Box>
                          )}
                        </>
                      )}
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={openSidebar ? 9 : 11.5}
                    sx={{
                      paddingTop: "0px !important",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <Box>
                      <Calendar
                        toast={toast}
                        onJobCreated={() => setJobListRefreshKey((k) => k + 1)}
                        calendarSelectedDate={calendarSelectedDate}
                        setCalendarSelectedDate={setCalendarSelectedDate}
                        calendarViewType={calendarViewType}
                        setCalendarViewType={setCalendarViewType}
                        appliedFilters={appliedFilters}
                        setAppliedFilters={setAppliedFilters}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value="2">
                <MapComponent
                  jobSites={jobSites}
                  equipment={jobAssets}
                  crews={jobLabor}
                  propSelectedDate={selectedDate}
                  onDateChange={handleDateChange}
                  onFilterClick={handleFilterClick}
                  onJobSiteSelect={setSelectedJobSite}
                  selectedJobSite={selectedJobSite}
                  apiKey={Google_API_Key}
                  setLoading={setLoading}
                />
              </TabPanel>
            </TabContext>
          </Box>
        </CardContent>
      </Card>

      {/* Add Event Sidebar */}
      <AddEventSidebar
        store={store} // You'll need to pass the store from Redux
        dispatch={dispatch}
        addEvent={addEvent} // You'll need to import these actions
        updateEvent={updateEvent}
        deleteEvent={deleteEvent}
        calendarApi={calendarApi} // You'll need to get this from Calendar component
        handleSelectEvent={handleSelectEvent}
        addEventSidebarOpen={addEventSidebarOpen}
        handleAddEventSidebarToggle={handleAddEventSidebarToggle}
        drawerWidth={400}
        toast={toast}
        onJobCreated={() => setJobListRefreshKey((k) => k + 1)}
      />

      {/*<ToastContainer />*/}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </UserLayout>
  );
};

export default DispatchBoard;